import { useState } from "react"
import "./createUser.css";
import Captcha from "../compents/Captch";
import apiClientInstance from "./TestApiClient";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function Resetpass() {
  const navigate = useNavigate();
  const { postData } = apiClientInstance();

  const [resetData, setResetData] = useState({
    cpassword: "",
    npassword: "",
    conPassword: "",
    captcha: "",
  });
  const [errors, setErrors] = useState({
    cpassword: "",
    npassword: "",
    conPassword: "",
    captcha: "",
  });

  const [message, setMessage] = useState("");
  const [reCaptcha, setReCaptcha] = useState(null);
  //read the values from the store

  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");

  // Change handler to update form data
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setResetData((prevData) => ({ ...prevData, [name]: value }));
  };

  //handle submitHandler
  const submitHandler = async (e) => {
    e.preventDefault();
    if (validation()) {
      setIsLoading(true);
      try {
        const data = await postData(
          `${process.env.REACT_APP_URL}/reset-pass`,
          resetData
        );
        //  const data = await axios.post(
        //   `${process.env.REACT_APP_URL}/reset-pass`,
        //   resetData
        // );
        setErr("");
        setMessage(data.message);

        await Swal.fire({
          title: "Success!",
          text: data.message || "Password changed successfully. You will be logged out.",
          icon: "success",
          confirmButtonText: "OK",
        });

        navigate("/logout");
        return;
      } catch (error) {
        console.log("In catch block...");
        console.log("Error:", error);
        console.error("FULL LOGIN ERROR:", error);

        // Comprehensive error logging
        if (error.response) {
          console.log("Error Response Status:", error.response.status);
          console.log("Error Response Data:", error.response.data);

          if (!error.response.data.success) {
            //if fails
            if (
              error.response.status === 400 &&
              error.response.data.message === "Invalid captcha"
            ) {
              // console.log("Invalid Captcha");
              console.log("Response Details:", error.response);

              setResetData((prevData) => ({
                ...prevData,
                captcha: "",
              }));
              console.log(error.response.data.data);
              setErr(error.response.data.message);
              setReCaptcha(error.response.data.data);
              setErrors((prevErrors) => ({
                ...prevErrors,
                cpassword: "",
                npassword: "",
                conPassword: "",
                captcha: "",
              }));
              setMessage("");
              return;
            }
            setResetData((prevData) => ({
              ...prevData,
              cpassword: "",
              npassword: "",
              conPassword: "",
              captcha: "",
            }));

            setErrors((prevErrors) => ({
              ...prevErrors,
              cpassword: "",
              npassword: "",
              conPassword: "",
              captcha: "",
            }));
            setMessage("");
            setErr(error.response.data.message);
          }
        }
        // Generic error handling
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          " failed to change password. Please try again.";
        setMessage("");
        setResetData((prevData) => ({
          ...prevData,
          cpassword: "",
          npassword: "",
          conPassword: "",
          captcha: "",
        }));
        setErrors((prevErrors) => ({
          ...prevErrors,
          cpassword: "",
          npassword: "",
          conPassword: "",
          captcha: "",
        }));
        setErr(errorMessage);
      } finally {
        setIsLoading(false);
      }

      // setMessage("user created & default password are sent to mail.");
    }
  };

  //validations
  function validation() {
    let valid = true;
    const errorsCopy = { ...errors };

    //validate current password
    const validateCPassword = resetData.cpassword.trim();
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]).{8,20}$/;

    if (!validateCPassword) {
      errorsCopy.cpassword = "Current password is required";
      valid = false;
    } else if (!passwordRegex.test(validateCPassword)) {
      errorsCopy.cpassword = "Not a Valid password String!";
      valid = false;
    } else {
      errorsCopy.cpassword = "";
    }

    //validate new password....
    const validateNPassword = resetData.npassword.trim();

    if (!validateNPassword) {
      errorsCopy.npassword = "New password is required";
      valid = false;
    } else if (!passwordRegex.test(validateNPassword)) {
      errorsCopy.npassword = "Not a Valid password String!";
      valid = false;
    } else {
      errorsCopy.npassword = "";
    }

    //validate new password and confirmed password....
    const validateConPassword = resetData.conPassword.trim();
    if (validateConPassword !== validateNPassword) {
      errorsCopy.conPassword =
        "new password and confirmed password must be same";
      valid = false;
    }

    //validate the captcha
    const validateCaptcha = resetData.captcha.trim();
    const captchaRegex = /^[A-Za-z0-9]{6}$/;
    if (!validateCaptcha) {
      errorsCopy.captcha = "Captcha is required";
      valid = false;
    } else if (!captchaRegex.test(validateCaptcha)) {
      errorsCopy.captcha =
        "invalid characters in captcha! Please enter 6 characters using only letters and numbers";
      valid = false;
    } else {
      errorsCopy.captcha = "";
    }

    setErrors(errorsCopy);
    return valid;
  }
  return (
    <div className="createUser">
      <div className="createUserContainer">
        <h2 className="resetPassTitle">Change Password</h2>
        <form id="passwordChangeForm" onSubmit={submitHandler} autoComplete="off">
          <div className="form-group">
            <label for="cpassword">Current password:</label>
            <input
              type="password"
              id="cpassword"
              name="cpassword"
              value={resetData.cpassword}
              onChange={changeHandler}
              placeholder="Enter current password"
              style={{ width: "100%" }}
              maxLength="20"
              autoComplete="off"
            />
            {errors.cpassword && (
              <span
                className="invalid-feedback d-block"
                style={{ color: "tomato" }}
              >
                {errors.cpassword}
              </span>
            )}
          </div>

          <div className="form-group">
            <label for="npassword">New password</label>
            <input
              type="password"
              id="npassword"
              name="npassword"
              placeholder="Enter new password"
              value={resetData.npassword}
              onChange={changeHandler}
              style={{ width: "100%" }}
              maxLength="20"
              autoComplete="new-password"
            />
            <p className="info">
              Password must be 8-20 characters long, contain uppercase,
              lowercase letters, numbers, and special characters!
            </p>
            {errors.npassword && (
              <span
                className="invalid-feedback d-block"
                style={{ color: "tomato" }}
              >
                {errors.npassword}
              </span>
            )}
          </div>
          <div className="form-group">
            <label for="conPassword">Confirm new password:</label>
            <input
              type="password"
              placeholder="Enter new password again"
              name="conPassword"
              id="conPassword"
              value={resetData.conPassword}
              onChange={changeHandler}
              style={{ width: "100%" }}
              maxLength="20"
              autoComplete="new-password"
            />

            {errors.conPassword && (
              <span
                className="invalid-feedback d-block"
                style={{ color: "tomato" }}
              >
                {errors.conPassword}
              </span>
            )}
          </div>
          <Captcha reCaptcha={reCaptcha} />

          <div className="form-group">
            <label for="captcha">Captcha:</label>
            <input
              type="text"
              name="captcha"
              id="captcha"
              maxLength="6"
              value={resetData.captcha}
              onChange={changeHandler}
              style={{ width: "100%" }}
              placeholder="Enter Captcha"
              autoComplete="one-time-code"
            />

            {errors.captcha && (
              <span className="invalid-feedback d-block">{errors.captcha}</span>
            )}
          </div>
          <div className="form-group">
            <button type="submit" className="loginButton" disabled={isLoading}>
              {isLoading ? <div className="spinner"></div> : "Change Password"}
            </button>
          </div>
          {err && <p style={{ color: "tomato", textAlign: "center" }}>{err}</p>}
          {message !== "" && (
            <span style={{ color: "teal", textAlign: "center" }}>
              {message}
            </span>
          )}
        </form>
      </div>
    </div>
  );
}
export default Resetpass;